<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 align-items-center justify-content-between mb-3">
  <span class="p-input-icon-right">
    <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" />
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="clearFilters()"></i>
  </span>
  <p-button label="Nueva cola" icon="pi pi-plus" (click)="edit(null)"></p-button>
</div>
-->

<p-table #grid [value]="queues" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
      <th pSortableColumn="strategy">Estrategia <p-sortIcon field="strategy"></p-sortIcon></th>
      <th pSortableColumn="timeout">Timeout <p-sortIcon field="timeout"></p-sortIcon></th>
      <th>Miembros</th>
      <th width="120"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-queue>
    <tr (dblclick)="edit(queue.id)" class="cursor-pointer">
      <td>{{queue.name}}</td>
      <td>{{queue.strategy}}</td>
      <td>{{queue.timeout}}</td>
      <td>
        <p-badge [value]="queue.memberCount ?? 0" severity="info"></p-badge>
      </td>
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button (click)="delete(queue)" [rounded]="true" [text]="false" severity="danger"
            pTooltip="Eliminar cola" tooltipPosition="top">
            <i class="pi pi-trash"></i>
          </p-button>
          <p-button (click)="edit(queue.id)" [rounded]="true" [text]="false"
            pTooltip="Editar cola" tooltipPosition="top">
            <i class="pi pi-pencil"></i>
          </p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">No se han encontrado colas</td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>
